import React from "react";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const TournamentNotFound = (props) => (
  <div
    style={{
      width: "95%",
      textAlign: "center",
      marginBottom: 20,
      whiteSpace: "normal",
      marginTop: 100,
    }}
  >
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <svg style={props.styles} viewBox="0 0 285 170">
        <g
          id="Error"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Group-4"
            transform="translate(0.000000, 2.000000)"
            fill="#F7F8F9"
          >
            <path
              d="M216.516754,87.3044335 C221.49711,87.3044335 225.534488,91.3418105 225.534488,96.3221675 C225.534488,101.302524 221.49711,105.339901 216.516754,105.339901 L127.403926,105.339901 C122.423569,105.339901 118.386192,101.302524 118.386192,96.3221675 C118.386192,91.3418105 122.423569,87.3044335 127.403926,87.3044335 L144.685494,87.3044335 C149.665851,87.3044335 153.703228,83.2670565 153.703228,78.2866995 C153.703228,73.3063425 149.665851,69.2689655 144.685494,69.2689655 L144.685494,69.2689655 L73.5304819,69.2689655 C68.5501249,69.2689655 64.5127479,65.2315885 64.5127479,60.2512315 C64.5127479,55.2708746 68.5501249,51.2334975 73.5304819,51.2334975 L126.727679,51.2334975 C131.708036,51.2334975 135.745413,47.1961205 135.745413,42.2157635 C135.745413,37.2354066 131.708036,33.1980296 126.727679,33.1980296 L126.727679,33.1980296 L73.5304819,33.1980296 C68.5501249,33.1980296 64.5127479,29.1606525 64.5127479,24.1802956 C64.5127479,19.1999386 68.5501249,15.1625616 73.5304819,15.1625616 L270.390198,15.1625616 C275.370555,15.1625616 279.407932,19.1999386 279.407932,24.1802956 C279.407932,29.1606525 275.370555,33.1980296 270.390198,33.1980296 L217.193001,33.1980296 C212.212644,33.1980296 208.175267,37.2354066 208.175267,42.2157635 C208.175267,47.1961205 212.212644,51.2334975 217.193001,51.2334975 L217.193001,51.2334975 L270.390198,51.2334975 C275.370555,51.2334975 279.407932,55.2708746 279.407932,60.2512315 C279.407932,65.2315885 275.370555,69.2689655 270.390198,69.2689655 L199.235186,69.2689655 C194.254829,69.2689655 190.217452,73.3063425 190.217452,78.2866995 C190.217452,83.2670565 194.254829,87.3044335 199.235186,87.3044335 L199.235186,87.3044335 L216.516754,87.3044335 Z"
              id="Combined-Shape"
              transform="translate(171.960340, 60.251232) rotate(-8.000000) translate(-171.960340, -60.251232) "
            ></path>
            <path
              d="M158.004006,132.141872 C162.984363,132.141872 167.02174,136.179249 167.02174,141.159606 C167.02174,146.139963 162.984363,150.17734 158.004006,150.17734 L68.8911785,150.17734 C63.9108215,150.17734 59.8734445,146.139963 59.8734445,141.159606 C59.8734445,136.179249 63.9108215,132.141872 68.8911785,132.141872 L86.1727463,132.141872 C91.1531033,132.141872 95.1904803,128.104495 95.1904803,123.124138 C95.1904803,118.143781 91.1531033,114.106404 86.1727463,114.106404 L86.1727463,114.106404 L15.017734,114.106404 C10.037377,114.106404 6,110.069027 6,105.08867 C6,100.108313 10.037377,96.070936 15.017734,96.070936 L68.2149315,96.070936 C73.1952885,96.070936 77.2326655,92.0335589 77.2326655,87.053202 C77.2326655,82.072845 73.1952885,78.035468 68.2149315,78.035468 L68.2149315,78.035468 L15.017734,78.035468 C10.037377,78.035468 6,73.998091 6,69.017734 C6,64.037377 10.037377,60 15.017734,60 L211.87745,60 C216.857807,60 220.895184,64.037377 220.895184,69.017734 C220.895184,73.998091 216.857807,78.035468 211.87745,78.035468 L158.680253,78.035468 C153.699896,78.035468 149.662519,82.072845 149.662519,87.053202 C149.662519,92.0335589 153.699896,96.070936 158.680253,96.070936 L158.680253,96.070936 L211.87745,96.070936 C216.857807,96.070936 220.895184,100.108313 220.895184,105.08867 C220.895184,110.069027 216.857807,114.106404 211.87745,114.106404 L140.722438,114.106404 C135.742081,114.106404 131.704704,118.143781 131.704704,123.124138 C131.704704,128.104495 135.742081,132.141872 140.722438,132.141872 L140.722438,132.141872 L158.004006,132.141872 Z"
              id="Combined-Shape-Copy"
              transform="translate(113.447592, 105.088670) scale(-1, -1) rotate(-8.000000) translate(-113.447592, -105.088670) "
            ></path>
          </g>
          <g id="Group-3" transform="translate(65.000000, 4.000000)">
            <rect
              id="Rectangle"
              stroke="currentColor"
              strokeWidth="4.5"
              x="46"
              y="115"
              width="64"
              height="35"
            ></rect>
            <rect
              id="Rectangle-Copy"
              stroke="currentColor"
              strokeWidth="4.5"
              x="56"
              y="123"
              width="44"
              height="19"
            ></rect>
            <path
              d="M120.4,-5.68434189e-14 C121.83594,-5.71071968e-14 123,1.16405965 123,2.6 L123,44.8424274 C123,57.2375386 118.336533,68.8618414 109.009599,79.7153356 C96.0669998,94.7762796 82.9059423,97.0534357 84.7436725,114.945236 L78.144,114.997 L78.1441649,115 L78,114.998 L77.8558351,115 L77.855,114.997 L71.2563275,114.945236 C73.0756804,97.2323537 60.1947215,94.8233842 47.3787291,80.1633572 L46.9904008,79.7153356 C37.6634669,68.8618414 33,57.2375386 33,44.8424274 L33,44.8424274 L33,2.6 C33,1.16405965 34.1640597,-5.71071968e-14 35.6,-5.68434189e-14 L35.6,-5.68434189e-14 L120.4,-5.68434189e-14 Z"
              id="Combined-Shape"
              stroke="currentColor"
              strokeWidth="4.5"
            ></path>
            <g
              id="Group"
              transform="translate(115.000000, 10.000000)"
              stroke="currentColor"
              strokeWidth="4.5"
            >
              <path
                d="M7.89753832,0.775096208 L35.3895206,0.775096208 C38.2000938,0.775096208 40.4785136,3.06015902 40.4785136,5.87892685 L40.4785136,30.7420773 C40.4785136,47.292384 27.1008436,60.7090584 10.5986514,60.7090584 L0.869040592,60.7090584"
                id="Path-4"
              ></path>
              <path
                d="M7.9880376,10.1130761 L28.6950064,10.1130761 C30.100293,10.1130761 31.2395029,11.2556075 31.2395029,12.6649914 C31.2395029,12.7177972 31.2378686,12.7705903 31.2346025,12.8232943 L30.3321349,27.3857971 C29.6911819,37.7284176 22.5951504,46.5318221 12.6458442,49.3275783 L5.4547358,51.3482806"
                id="Path-4-Copy"
              ></path>
            </g>
            <g
              id="Group-Copy"
              transform="translate(20.500000, 40.500000) scale(-1, 1) translate(-20.500000, -40.500000) translate(0.000000, 10.000000)"
              stroke="currentColor"
              strokeWidth="4.5"
            >
              <path
                d="M7.89753832,0.775096208 L35.3895206,0.775096208 C38.2000938,0.775096208 40.4785136,3.06015902 40.4785136,5.87892685 L40.4785136,30.7420773 C40.4785136,47.292384 27.1008436,60.7090584 10.5986514,60.7090584 L0.869040592,60.7090584"
                id="Path-4"
              ></path>
              <path
                d="M7.9880376,10.1130761 L28.6950064,10.1130761 C30.100293,10.1130761 31.2395029,11.2556075 31.2395029,12.6649914 C31.2395029,12.7177972 31.2378686,12.7705903 31.2346025,12.8232943 L31.2346025,12.8232943 L30.3321349,27.3857971 C29.6911819,37.7284176 22.5951504,46.5318221 12.6458442,49.3275783 L5.4547358,51.3482806"
                id="Path-4-Copy"
              ></path>
            </g>
            <rect
              id="Rectangle-2"
              fill="currentColor"
              x="28"
              y="149"
              width="100"
              height="4"
              rx="2"
            ></rect>
            <rect
              id="Rectangle-2-Copy"
              fill="currentColor"
              x="11"
              y="160"
              width="24"
              height="4"
              rx="2"
            ></rect>
            <rect
              id="Rectangle-2-Copy-2"
              fill="currentColor"
              x="49"
              y="160"
              width="19"
              height="4"
              rx="2"
            ></rect>
            <rect
              id="Rectangle-2-Copy-3"
              fill="currentColor"
              x="76"
              y="160"
              width="13"
              height="4"
              rx="2"
            ></rect>
            <rect
              id="Rectangle-2-Copy-4"
              fill="currentColor"
              x="102"
              y="160"
              width="53"
              height="4"
              rx="2"
            ></rect>
          </g>
          <circle
            id="Oval"
            stroke="currentColor"
            strokeWidth="6"
            cx="143"
            cy="61"
            r="7"
          ></circle>
          <polyline
            id="Line"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="122 44 131 36.8277094 122 30"
          ></polyline>
          <polyline
            id="Line"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(159.500000, 37.000000) scale(-1, 1) translate(-159.500000, -37.000000) "
            points="155 44 164 36.8277094 155 30"
          ></polyline>
          <path
            d="M71,115 L60,125 M60,115 L71,125"
            id="Line-4"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <ellipse
            id="Oval"
            fill="currentColor"
            cx="84"
            cy="97.5"
            rx="5"
            ry="5.5"
          ></ellipse>
          <circle
            id="Oval"
            fill="currentColor"
            cx="240"
            cy="102"
            r="5"
          ></circle>
          <path
            d="M213.346154,92.6538462 L197.653846,108.346154 M197.653846,92.6538462 L213.346154,108.346154"
            id="Line-5"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </svg>
      <Typography variant="h6">
        {languages.general.tournamentNotFound}
      </Typography>
      {/* <Typography variant="subtitle1" style={{ fontSize: 17 }}>
        {}
      </Typography> */}
      <div style={{ marginTop: 10 }}>
        <Button
          variant={"outlined"}
          onClick={props.handleBack}
          size="small"
          style={{ marginRight: 0 }}
        >
          {languages.general.back}
        </Button>
      </div>
    </div>
  </div>
);

export default TournamentNotFound;
